import { useState, useMemo, useEffect } from 'react';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { useLocalStorage } from 'src/shared/hooks/useLocalStorage';
import { LocalStorageKeys } from 'src/shared/models/enums/localStorageKeys.enum';
import SearchField from 'src/shared/components/form/searchField';
import { PageFilterSection } from 'src/shared/components/organisms/pageFilterSection';
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from 'src/shared/models/enums/gridFilterConfig';
import { EInvoiceAddressSearchFilter } from '../models/eInvoiceAddressSearchFilter';
import { EInvoiceAddressDataGrid } from '../components/eInvoiceAddressDataGrid';

export const EInvoiceAddressOverviewPage = () => {
  const isMounted = useIsMounted();
  const [tempSearchString, setTempSearchString] = useState<string | undefined>(undefined);
  const [searchInitialized, setSearchInitialized] = useState<boolean>(false);

  const [addressSearchFilter, setAddressSearchFilter] = useLocalStorage(LocalStorageKeys.EInvoiceAddressFilter, {
    sortCol: 'eInvoiceAddress_id',
    sortDir: 'desc',
    pageIndex: DEFAULT_PAGE_INDEX,
    pageSize: DEFAULT_PAGE_SIZE,
  } as EInvoiceAddressSearchFilter);

  const searchFilter: EInvoiceAddressSearchFilter = useMemo(() => {
    return {
      filter: addressSearchFilter?.filter,
      pageSize: addressSearchFilter?.pageSize,
      pageIndex: addressSearchFilter?.pageIndex,
      sortCol: addressSearchFilter?.sortCol,
      sortDir: addressSearchFilter?.sortDir,
    } as EInvoiceAddressSearchFilter;
  }, [
    addressSearchFilter?.filter,
    addressSearchFilter?.pageIndex,
    addressSearchFilter?.pageSize,
    addressSearchFilter?.sortCol,
    addressSearchFilter?.sortDir,
  ]);

  useEffect(() => {
    if (isMounted() && searchInitialized) {
      if (tempSearchString === '') {
        setAddressSearchFilter((prev) => ({ ...prev, ...{ filter: '', pageIndex: 0 } }));
      }
      if (tempSearchString && tempSearchString.length >= 2) {
        setAddressSearchFilter((prev) => ({ ...prev, ...{ filter: tempSearchString, pageIndex: 0 } }));
      } else {
        setAddressSearchFilter((prev) => ({ ...prev, ...{ filter: '', pageIndex: 0 } }));
      }
    }
  }, [isMounted, searchInitialized, setAddressSearchFilter, tempSearchString]);

  return (
    <>
      <PageFilterSection
        leftContent={
          <SearchField
            initialValue={searchFilter.filter || ''}
            onSearch={(newSearchString) => {
              setSearchInitialized(true);
              setTempSearchString(newSearchString);
            }}
          />
        }
      />
      <EInvoiceAddressDataGrid
        searchFilter={searchFilter}
        isOther={false}
        searchFilterCallback={(newFilter) =>
          setAddressSearchFilter((prev) => ({
            ...prev,
            ...newFilter,
          }))
        }
      />
    </>
  );
};
